import logoCapiro from "../images/companies/logo-capiro.jpg"
import logoCeco from "../images/companies/logo-cecoltec.png"
import logoCoat from "../images/companies/logo-coatings.png"
import logoEcos from "../images/companies/logo-ecosphaira.png"

export const CompaniesMessages = {
  company1: {
    imagePath: `${logoEcos}`,
    title: "Ecosphira",
    link: "https://ecosphairacolombia.com/",
  },
  company2: {
    imagePath: `${logoCeco}`,
    title: "Cecoltec",
    link: "https://www.cecoltec.com/",
  },
  company3: {
    imagePath: `${logoCoat}`,
    title: "Coatings",
    link: "http://coatings.com.co/",
  },
  company4: {
    imagePath: `${logoCapiro}`,
    title: "Capiro",
    link: "https://www.capiro.co/",
  },
}
